// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"324e57e3","148":"adfdfdd2","195":"1e87e0bb","238":"77d229c7","316":"140b67d8","474":"d6c640e0","554":"56894213","667":"452fd963","753":"098fd76f","787":"2aeee0b2"}[chunkId] + ".chunk.js";
};